import { render, staticRenderFns } from "./NumeroContaField.vue?vue&type=template&id=96338398&scoped=true&"
import script from "./NumeroContaField.vue?vue&type=script&lang=js&"
export * from "./NumeroContaField.vue?vue&type=script&lang=js&"
import style0 from "./NumeroContaField.vue?vue&type=style&index=0&id=96338398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96338398",
  null
  
)

export default component.exports